import type { RepositoryLocale } from "../../app/services/locales"

export function sortRepositoryLocales(repositoryLocales: RepositoryLocale[]) {
  return repositoryLocales
    .slice()
    .sort((a, b) =>
      a.isMaster !== b.isMaster
        ? Number(b.isMaster) - Number(a.isMaster)
        : a.label.localeCompare(b.label)
    )
}
